export const formFieldsId = {
  name: 'first_name',
  lastName: 'last_name',
  username: 'username',
  email: 'email',
}
